import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'supplier_subcontractor_receives_train_comm_on_due_diligence'

export const dataPointDefinition = {
  retracedId: 'supplier_subcontractor_receives_train_comm_on_due_diligence',
  name: 'Supplier / subcontractor receives training/ communication on due diligence requirements',
  description:
    "Subcontractors are entities or persons who are not part of the facility but are used by the facility to complete part or all of the facility's production process. Subcontractors are NOT labor recruiters/ labor agencies, service providers (e.g. maintenance, cleaning, security, canteen workers), or ma",
  meta: {
    slcpMeta: {
      key: 'ms-5--13-15x',
      number: 'MS-DO-31-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-5--13-15x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32560,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
